import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b27626"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Users", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Subscribed users", -1))

import DashboardLayout from "@/views/layouts/DashboardLayout.vue";
import UsersTable from "@/components/Pages/Dashboard/UsersTable.vue";
import SubscribedUsers from "@/components/Pages/Dashboard/SubscribedUsers.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(UsersTable, { class: "mt--50" }),
      _hoisted_2,
      _createVNode(SubscribedUsers)
    ]),
    _: 1
  }))
}
}

})